import { ServiceLevelsKpisActionTypes } from './constants';

export const INIT_STATE = {
    loadingShipmentsServiceLevels: false,
    errorGetShipmentsServiceLevels: null,
    shipmentsServiceLevels: null,
    loadingShipmentsDayServiceLevels: false,
    errorGetShipmentsDayServiceLevels: null,
    shipmentsDayServiceLevels: null,
    loadingShipmentsServiceLevelsByTimeframe: false,
    errorGetShipmentsServiceLevelsByTimeframe: null,
    shipmentsServiceLevelsByTimeframe: null,
    loadingShipmentsAggregatedCost: false,
    errorGetShipmentsAggregatedCost: null,
    shipmentsAggregatedCost: null,
};

type ServiceLevelsKpisAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for shipments
type State = {
    loadingShipmentsServiceLevels: Boolean,
    errorGetShipmentsServiceLevels: null,
    shipmentsServiceLevels: any,
    loadingShipmentsDayServiceLevels: Boolean,
    errorGetShipmentsDayServiceLevels: null,
    shipmentsDayServiceLevels: any,
    loadingShipmentsServiceLevelsByTimeframe: Boolean,
    errorGetShipmentsServiceLevelsByTimeframe: null,
    shipmentsServiceLevelsByTimeframe: any,
    loadingShipmentsAggregatedCost: Boolean,
    errorGetShipmentsAggregatedCost: null,
    shipmentsAggregatedCost: any,
};

const ServiceLevelsKpis = (state: State = INIT_STATE, action: ServiceLevelsKpisAction): any => {
    switch (action.type) {
        case ServiceLevelsKpisActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_REQUEST: {
                    return { ...state, loadingShipmentsServiceLevels: false, shipmentsServiceLevels: action.payload.data };
                }
                case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST: {
                    return { ...state, loadingShipmentsDayServiceLevels: false, shipmentsDayServiceLevels: action.payload.data };
                }
                case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST: {
                    return { ...state, loadingShipmentsServiceLevelsByTimeframe: false, shipmentsServiceLevelsByTimeframe: action.payload.data };
                }
                case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_AGGREGATED_COST_REQUEST: {
                    return { ...state, loadingShipmentsAggregatedCost: false, shipmentsAggregatedCost: action.payload.data };
                }
                default:
                    return { ...state, loadingShipmentsServiceLevels: false, loadingShipmentsDayServiceLevels: false, loadingShipmentsServiceLevelsByTimeframe: false, loadingShipmentsAggregatedCost: false };
            }

        case ServiceLevelsKpisActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_REQUEST: {
                    return { ...state, loadingShipmentsServiceLevels: false, errorGetShipmentsServiceLevels: action.payload.error };
                }
                case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST: {
                    return { ...state, loadingShipmentsDayServiceLevels: false, errorGetShipmentsDayServiceLevels: action.payload.error };
                }
                case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST: {
                    return { ...state, loadingShipmentsServiceLevelsByTimeframe: false, errorGetShipmentsServiceLevelsByTimeframe: action.payload.error };
                }
                case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_AGGREGATED_COST_REQUEST: {
                    return { ...state, loadingShipmentsAggregatedCost: false, errorGetShipmentsAggregatedCost: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_REQUEST:
            return { ...state, loadingShipmentsServiceLevels: true, shipmentsServiceLevels: null };
        case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST:
            return { ...state, loadingShipmentsDayServiceLevels: true, shipmentsDayServiceLevels: null };
        case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST:
            return { ...state, loadingShipmentsServiceLevelsByTimeframe: true, shipmentsServiceLevelsByTimeframe: null };
        case ServiceLevelsKpisActionTypes.GET_SHIPMENTS_AGGREGATED_COST_REQUEST:
            return { ...state, loadingShipmentsAggregatedCost: true, shipmentsAggregatedCost: null };
        default:
            return { ...state };
    }
};

export default ServiceLevelsKpis;
